import api from "./api";

const BASE_ENDPOINT = '/relatorio';

/**
 * Traz uma lista de colaboradores e seus benefícios 
 * totais (sintetico) ou em detalhes (analítico) 
 * @param {{
 *  apresentacao: 'analitico' | 'sintetico',
 *  filtros
 * }}
 */
const getColaboradorBeneficio = ({ apresentacao, ...filtros }) => {
    return api.get(
        `${BASE_ENDPOINT}/colaborador-beneficio`,
        { params: { apresentacao, filtros } }
    );
}

const getPredictedCost = (key, initialDate, finalDate) => {
    return api.get(`${BASE_ENDPOINT}/custo-previsto/${key}/${initialDate}/${finalDate}`);
}

const getPredictedCostYear = (key, data) => {
    return api.get(`${BASE_ENDPOINT}/custo-previsto/ano/${key}/${data}`);
}

const getDadosRelatoriosCustosToList = () =>{
    return api.get(`${BASE_ENDPOINT}/buscar-relatorios`)
}

const postDadosRelatoriosCustosToList = ( dados ) => {
    return api.post(`${BASE_ENDPOINT}/salvar-relatorio`, dados)
}

const deleteDadosRelatorioCustosToList = ( key, ano ) => {
    return api.delete(`${BASE_ENDPOINT}/deletar-relatorio/${key}/${ano}`)
}

const getDadosRelatorio = ( key, ano ) => {
    return api.get(`${BASE_ENDPOINT}/buscar-nome-relatorio/${key}/${ano}`)
}

const getComparativoCustoTodos = (projeto, id) => {
    return api.get(`${BASE_ENDPOINT}/comparativo-custo/todos/${projeto}/${id}`)
}

const getComparativoCustoPeriodo = (projeto, id, dataInicial, dataFinal) => {
    return api.get(`${BASE_ENDPOINT}/comparativo-custo/periodo/${projeto}/${id}/${dataInicial}/${dataFinal}`)
}

function getValorVendaTodos(key) {
    return api.get(`${BASE_ENDPOINT}/comparativo-faturamento/todos/${key}`);
}

function getValorVendaPeriod(key, dataInicial, dataFinal) {
    return api.get(`${BASE_ENDPOINT}/comparativo-faturamento/periodo/${key}/${dataInicial}/${dataFinal}`);
}

function getRelatorioCapacidadeArea(dataInicial, dataFinal) {
    return api.get(`${BASE_ENDPOINT}/capacidade-area/${dataInicial}/${dataFinal}`);
}

function getRelatorioCapacidadeProjeto(dataInicial, dataFinal, projetosSelecionados) {
    // Extrair apenas os IDs dos projetos e criar string separada por vírgulas
    const projectIds = projetosSelecionados.map(projeto => projeto.id).join(',');
    return api.get(`${BASE_ENDPOINT}/capacidade-projeto/${dataInicial}/${dataFinal}/${projectIds}`);
}

function getFluxoCaixa(value, dataInicial, dataFinal) {
    return api.get(`${BASE_ENDPOINT}-fluxo-caixa${value}/${dataInicial}/${dataFinal}`);
}

function getResultadoDoClientePeriodo(dataInicial, dataFinal, clienteSelecionado) {
    return api.get(`${BASE_ENDPOINT}-resultados-cliente/projects/${dataInicial}/${dataFinal}/${clienteSelecionado}`);
}

function getResultadoDoClienteTotal(clienteSelecionado) {
    return api.get(`${BASE_ENDPOINT}-resultados-cliente/projects/${clienteSelecionado}`);
}

function getResultadoDoLiderPeriodo(dataInicial, dataFinal, liderSelecionado) {
    return api.get(`${BASE_ENDPOINT}-resultados-cliente/projects-lead/${dataInicial}/${dataFinal}/${liderSelecionado}`);
}

function getResultadoDoLiderTotal(liderSelecionado) {
    return api.get(`${BASE_ENDPOINT}-resultados-cliente/projects-lead/${liderSelecionado}`);
}

function getRelatorioTurnover(dataInicial, dataFinal) {
    return api.get(`${BASE_ENDPOINT}/turnover/${dataInicial}/${dataFinal}`);
}

function getMetaTurnover() {
    return api.get(`${BASE_ENDPOINT}/turnover/meta`);
}

function createRelatoriosTurnoverHistoricoCapacidade() {
    return api.post(`${BASE_ENDPOINT}/turnover/criarAntigos`);
}

function getRelatorioHistoricoCapacidade(dataInicial, dataFinal) {
    return api.get(`${BASE_ENDPOINT}-capacidade-historico/${dataInicial}/${dataFinal}`);
}

function getMetaHistoricoCapacidade() {
    return api.get(`${BASE_ENDPOINT}-capacidade-historico/meta`);
}

function getRelatorioPontoJira(dataInicial, dataFinal) {
    return api.get(`ponto-two/folha-pagamento/${dataInicial}/${dataFinal}`);
}

function getRelatorioHorasExtras(dataInicial, dataFinal) {
    return api.get(`ponto-two/horas-extras/${dataInicial}/${dataFinal}`);
}

function getStatusCreateRelatoriosTurnoverHistoricoCapacidade() {
    return api.get(`${BASE_ENDPOINT}/turnover/status`);
}

function getRelatorioRelacaoHoras(dataInicial, dataFinal) {
    return api.get(`ponto-two/relacao-horas/${dataInicial}/${dataFinal}`);
}

function recalcularHistoricoCapacidade(data) {
    return api.put(`${BASE_ENDPOINT}-capacidade-historico/update`, { "data": data });
}

function getHistoricoHorasExtras(dataInicial, dataFinal) {
    return api.get(`/ponto-two/apuracao-horas-extras/${dataInicial}/${dataFinal}`);
}

function salvarApuracaoHorasExtrasRetroativo() {
    return api.post('ponto-two/salvar/retroativo/apuracao-horas-extras');
}

function getBancoDeHoras(dataInicial, dataFinal) {
    return api.get(`/ponto-two/time-bank/${dataInicial}/${dataFinal}`);
}

function calcularBancoDeHorasRetroativo() {
    return api.post('/ponto-two/time-bank/save-retroactive');
}

const RelatorioApiService = {
    getColaboradorBeneficio,
    getPredictedCost,
    getPredictedCostYear,
    getDadosRelatoriosCustosToList,
    postDadosRelatoriosCustosToList,
    deleteDadosRelatorioCustosToList,
    getDadosRelatorio,
    getComparativoCustoTodos,
    getComparativoCustoPeriodo,
    getValorVendaTodos,
    getValorVendaPeriod,
    getRelatorioCapacidadeArea,
    getRelatorioCapacidadeProjeto,
    getFluxoCaixa,
    getResultadoDoClientePeriodo,
    getResultadoDoClienteTotal,
    getResultadoDoLiderPeriodo,
    getResultadoDoLiderTotal,
    getRelatorioTurnover,
    getMetaTurnover,
    getRelatorioHistoricoCapacidade,
    getMetaHistoricoCapacidade,
    getRelatorioPontoJira,
    getRelatorioHorasExtras,
    createRelatoriosTurnoverHistoricoCapacidade,
    getStatusCreateRelatoriosTurnoverHistoricoCapacidade,
    getRelatorioRelacaoHoras,
    recalcularHistoricoCapacidade,
    getHistoricoHorasExtras,
    salvarApuracaoHorasExtrasRetroativo,
    getBancoDeHoras,
    calcularBancoDeHorasRetroativo
}

export default RelatorioApiService;